module.exports = __webpack_public_path__ + "static/sport/title.5558d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport3/title.png
// module id = +eic
// module chunks = 0